export function createPaymentStateSelector(state) {
  return state.local.payments.creation
}
